export const FRUITS = [
 
    {
      id: 1,
      text: './images/apple.png',
      correct: 'apple'
    },
    {
      id: 2,
      text: './images/banana.png',
      correct: 'banana'
    },
    {
      id: 3,
      text: './images/orange.png',
      correct: 'orange'
    },
    {
      id: 4,
      text: './images/grapes.png',
      correct: 'grapes'
    },
    {
      id: 5,
      text: './images/watermelon.png',
      correct: 'watermelon'
    },
    {
      id: 6,
      text: './images/pineapple.png',
      correct: 'pineapple'
    },
    {
      id: 7,
      text: './images/cherry.png',
      correct: 'cherry'
    },
    {
      id: 8,
      text: './images/pear.png',
      correct: 'pear'
    },
    {
      id: 9,
      text: './images/apricot.png',
      correct: 'apricot'
    },
    {
      id: 10,
      text: './images/litchi.png',
      correct: 'lichi'
    }
  ];
